// *** 酒店城市控件数据 ***
export const hotelCity = [
  { 'id': '36', 'name': '安庆', 'spell': 'Anqing', 'spellShort': 'aq' },
  { 'id': '37', 'name': '蚌埠', 'spell': 'Bangbu', 'spellShort': 'bb' },
  { 'id': '38', 'name': '巢湖', 'spell': 'Chaohu', 'spellShort': 'ch' },
  { 'id': '39', 'name': '池州', 'spell': 'Chizhou', 'spellShort': 'cz' },
  { 'id': '40', 'name': '滁州', 'spell': 'Chuzhou', 'spellShort': 'cz' },
  { 'id': '41', 'name': '阜阳', 'spell': 'Fuyang', 'spellShort': 'fy' },
  { 'id': '42', 'name': '合肥', 'spell': 'Hefei', 'spellShort': 'hf' },
  { 'id': '43', 'name': '淮北', 'spell': 'Huaibei', 'spellShort': 'hb' },
  { 'id': '44', 'name': '淮南', 'spell': 'Huainan', 'spellShort': 'hn' },
  { 'id': '45', 'name': '黄山', 'spell': 'Huangshan', 'spellShort': 'hs' },
  { 'id': '46', 'name': '六安', 'spell': 'Liuan', 'spellShort': 'la' },
  { 'id': '47', 'name': '马鞍山', 'spell': 'Maanshan', 'spellShort': 'mas' },
  { 'id': '48', 'name': '宿州', 'spell': 'Suzhou', 'spellShort': 'sz' },
  { 'id': '49', 'name': '铜陵', 'spell': 'Tongling', 'spellShort': 'tl' },
  { 'id': '50', 'name': '芜湖', 'spell': 'Wuhu', 'spellShort': 'wh' },
  { 'id': '51', 'name': '宣城', 'spell': 'Xuancheng', 'spellShort': 'xc' },
  { 'id': '52', 'name': '亳州', 'spell': 'BoZhou', 'spellShort': 'bz' },
  { 'id': '53', 'name': '北京', isHot: true, 'spell': 'Beijing', 'spellShort': 'bj' },
  { 'id': '54', 'name': '福州', isHot: true, 'spell': 'Fuzhou', 'spellShort': 'fz' },
  { 'id': '55', 'name': '龙岩', 'spell': 'Longyan', 'spellShort': 'ly' },
  { 'id': '56', 'name': '南平', 'spell': 'Nanping', 'spellShort': 'np' },
  { 'id': '57', 'name': '宁德', 'spell': 'Ningde', 'spellShort': 'nd' },
  { 'id': '58', 'name': '莆田', 'spell': 'Putian', 'spellShort': 'pt' },
  { 'id': '59', 'name': '泉州', 'spell': 'Quanzhou', 'spellShort': 'qz' },
  { 'id': '60', 'name': '三明', 'spell': 'Sanming', 'spellShort': 'sm' },
  { 'id': '61', 'name': '厦门', isHot: true, 'spell': 'Xiamen', 'spellShort': 'xm' },
  { 'id': '62', 'name': '漳州', 'spell': 'Zhangzhou', 'spellShort': 'zz' },
  { 'id': '63', 'name': '白银', 'spell': 'Baiyin', 'spellShort': 'by' },
  { 'id': '64', 'name': '定西', 'spell': 'Dingxi', 'spellShort': 'dx' },
  { 'id': '65', 'name': '甘南', 'spell': 'Gannan', 'spellShort': 'gn' },
  { 'id': '66', 'name': '嘉峪关', 'spell': 'Jiayuguan', 'spellShort': 'jyg' },
  { 'id': '67', 'name': '金昌', 'spell': 'Jinchang', 'spellShort': 'jc' },
  { 'id': '68', 'name': '酒泉', 'spell': 'Jiuquan', 'spellShort': 'jq' },
  { 'id': '69', 'name': '兰州', 'spell': 'Lanzhou', 'spellShort': 'lz' },
  { 'id': '70', 'name': '临夏', 'spell': 'Linxia', 'spellShort': 'nx' },
  { 'id': '71', 'name': '陇南', 'spell': 'Longnan', 'spellShort': 'ln' },
  { 'id': '72', 'name': '平凉', 'spell': 'Pingliang', 'spellShort': 'pl' },
  { 'id': '73', 'name': '庆阳', 'spell': 'Qingyang', 'spellShort': 'qy' },
  { 'id': '74', 'name': '天水', 'spell': 'Tianshui', 'spellShort': 'ts' },
  { 'id': '75', 'name': '武威', 'spell': 'Wuwei', 'spellShort': 'ww' },
  { 'id': '76', 'name': '张掖', 'spell': 'Zhangye', 'spellShort': 'zy' },
  { 'id': '77', 'name': '潮州', 'spell': 'Chaozhou', 'spellShort': 'cz' },
  { 'id': '78', 'name': '东莞', 'spell': 'DongGuan', 'spellShort': 'dg' },
  { 'id': '79', 'name': '佛山', 'spell': 'Foshan', 'spellShort': 'fs' },
  { 'id': '80', 'name': '广州', isHot: true, 'spell': 'Guangzhou', 'spellShort': 'gz' },
  { 'id': '81', 'name': '河源', 'spell': 'Heyuan', 'spellShort': 'hy' },
  { 'id': '82', 'name': '惠州', 'spell': 'Huizhou', 'spellShort': 'hz' },
  { 'id': '83', 'name': '江门', 'spell': 'Jiangmen', 'spellShort': 'jm' },
  { 'id': '84', 'name': '揭阳', 'spell': 'Jieyang', 'spellShort': 'jy' },
  { 'id': '85', 'name': '茂名', 'spell': 'Maoming', 'spellShort': 'mm' },
  { 'id': '86', 'name': '梅州', 'spell': 'Meizhou', 'spellShort': 'mz' },
  { 'id': '87', 'name': '清远', 'spell': 'Qingyuan', 'spellShort': 'qy' },
  {'id': '88', 'name': '汕头', 'spell': 'Shantou', 'spellShort': 'st'},
  { 'id': '89', 'name': '汕尾', 'spell': 'Shanwei', 'spellShort': 'sw' },
  { 'id': '90', 'name': '韶关', 'spell': 'Shaoguan', 'spellShort': 'sg' },
  { 'id': '91', 'name': '深圳', isHot: true, 'spell': 'Shenzhen', 'spellShort': 'sz' },
  { 'id': '92', 'name': '阳江', 'spell': 'Yangjiang', 'spellShort': 'yj' },
  { 'id': '93', 'name': '云浮', 'spell': 'Yunfu', 'spellShort': 'yf' },
  { 'id': '94', 'name': '湛江', 'spell': 'Zhanjiang', 'spellShort': 'zj' },
  { 'id': '95', 'name': '肇庆', 'spell': 'Zhaoqing', 'spellShort': 'zq' },
  { 'id': '96', 'name': '中山', 'spell': 'Zhongshan', 'spellShort': 'zs' },
  { 'id': '97', 'name': '珠海', 'spell': 'Zhuhai', 'spellShort': 'zh' },
  { 'id': '98', 'name': '百色', 'spell': 'Baise', 'spellShort': 'bs' },
  { 'id': '99', 'name': '北海', 'spell': 'Beihai', 'spellShort': 'bh' },
  { 'id': '100', 'name': '崇左', 'spell': 'Chongzuo', 'spellShort': 'cz' },
  { 'id': '101', 'name': '防城港', 'spell': 'Fangchenggang', 'spellShort': 'fcg' },
  { 'id': '102', 'name': '桂林', 'spell': 'Guilin', 'spellShort': 'gl' },
  { 'id': '103', 'name': '贵港', 'spell': 'Guigang', 'spellShort': 'gg' },
  { 'id': '104', 'name': '河池', 'spell': 'Hechi', 'spellShort': 'hc' },
  { 'id': '105', 'name': '贺州', 'spell': 'Hezhou', 'spellShort': 'hz' },
  { 'id': '106', 'name': '来宾', 'spell': 'Laibin', 'spellShort': 'lb' },
  { 'id': '107', 'name': '柳州', 'spell': 'Liuzhou', 'spellShort': 'lz' },
  { 'id': '108', 'name': '南宁', 'spell': 'Nanning', 'spellShort': 'nn' },
  { 'id': '109', 'name': '钦州', 'spell': 'Qinzhou', 'spellShort': 'qz' },
  { 'id': '110', 'name': '梧州', 'spell': 'Wuzhou', 'spellShort': 'wz' },
  { 'id': '111', 'name': '玉林', 'spell': 'Yulin', 'spellShort': 'yl' },
  { 'id': '112', 'name': '安顺', 'spell': 'Anshun', 'spellShort': 'as' },
  { 'id': '113', 'name': '毕节', 'spell': 'Bijie', 'spellShort': 'bj' },
  { 'id': '114', 'name': '贵阳', 'spell': 'Guiyang', 'spellShort': 'gy' },
  { 'id': '115', 'name': '六盘水', 'spell': 'Liupanshui', 'spellShort': 'lps' },
  { 'id': '116', 'name': '黔东', 'spell': 'Qiandongnanmiaozudongzuzizhizhou', 'spellShort': 'qd' },
  { 'id': '117', 'name': '黔南', 'spell': 'Qiannanbuyizumiaozuzizhizhou', 'spellShort': 'qn' },
  { 'id': '118', 'name': '黔西', 'spell': 'Qianxinanbuyizumiaozuzizhizhou', 'spellShort': 'qx' },
  { 'id': '119', 'name': '铜仁', 'spell': 'Tongren', 'spellShort': 'tr' },
  { 'id': '120', 'name': '遵义', 'spell': 'Zunyi', 'spellShort': 'zy' },
  { 'id': '121', 'name': '白沙', 'spell': 'Baishalizuzizhixian', 'spellShort': 'bs' },
  { 'id': '122', 'name': '保亭', 'spell': 'Baotinglizumiaozuzizhixian', 'spellShort': 'bt' },
  { 'id': '123', 'name': '昌江', 'spell': 'Changjianglizuzizhixian', 'spellShort': 'cj' },
  { 'id': '124', 'name': '澄迈县', 'spell': 'Chengmaixian', 'spellShort': 'cm' },
  { 'id': '125', 'name': '定安县', 'spell': 'Dinganxian', 'spellShort': 'ad' },
  { 'id': '126', 'name': '东方', 'spell': 'Dongfang', 'spellShort': 'df' },
  { 'id': '127', 'name': '海口', 'spell': 'Haikou', 'spellShort': 'hk' },
  { 'id': '128', 'name': '乐东', 'spell': 'Ledonglizuzizhixian', 'spellShort': 'ld' },
  { 'id': '129', 'name': '临高县', 'spell': 'Lingaoxian', 'spellShort': 'lg' },
  { 'id': '130', 'name': '陵水', 'spell': 'Lingshui', 'spellShort': 'ls' },
  { 'id': '131', 'name': '琼海', 'spell': 'Qionghai', 'spellShort': 'qh' },
  { 'id': '132', 'name': '琼中', 'spell': 'Qiongzhonglizumiaozuzizhixian', 'spellShort': 'qz' },
  { 'id': '133', 'name': '三亚', isHot: true, 'spell': 'Sanya', 'spellShort': 'sy' },
  { 'id': '134', 'name': '屯昌县', 'spell': 'Tunchangxian', 'spellShort': 'tc' },
  { 'id': '135', 'name': '万宁', 'spell': 'Wanning', 'spellShort': 'wn' },
  { 'id': '136', 'name': '文昌', 'spell': 'Wenchang', 'spellShort': 'wc' },
  { 'id': '137', 'name': '五指山', 'spell': 'Wuzhishan', 'spellShort': 'wzs' },
  { 'id': '138', 'name': '儋州', 'spell': 'DanZhou', 'spellShort': 'dz' },
  { 'id': '139', 'name': '保定', 'spell': 'Baoding', 'spellShort': 'bd' },
  { 'id': '140', 'name': '沧州', 'spell': 'Cangzhou', 'spellShort': 'cz' },
  { 'id': '141', 'name': '承德', 'spell': 'Chengde', 'spellShort': 'cd' },
  { 'id': '142', 'name': '邯郸', 'spell': 'Handan', 'spellShort': 'hd' },
  { 'id': '143', 'name': '衡水', 'spell': 'Hengshui', 'spellShort': 'hs' },
  { 'id': '144', 'name': '廊坊', 'spell': 'Langfang', 'spellShort': 'lf' },
  { 'id': '145', 'name': '秦皇岛', 'spell': 'Qinhuangdao', 'spellShort': 'qhd' },
  { 'id': '146', 'name': '石家庄', 'spell': 'Shijiazhuang', 'spellShort': 'sjz' },
  { 'id': '147', 'name': '唐山', 'spell': 'Tangshan', 'spellShort': 'ts' },
  { 'id': '148', 'name': '邢台', 'spell': 'Xingtai', 'spellShort': 'xt' },
  { 'id': '149', 'name': '张家口', 'spell': 'Zhangjiakou', 'spellShort': 'zjk' },
  { 'id': '150', 'name': '安阳', 'spell': 'Anyang', 'spellShort': 'ay' },
  { 'id': '151', 'name': '鹤壁', 'spell': 'Hebi', 'spellShort': 'hb' },
  { 'id': '152', 'name': '济源', 'spell': 'Jiyuan', 'spellShort': 'jy' },
  { 'id': '153', 'name': '焦作', 'spell': 'Jiaozuo', 'spellShort': 'jz' },
  { 'id': '154', 'name': '开封', 'spell': 'Kaifeng', 'spellShort': 'kf' },
  { 'id': '155', 'name': '洛阳', 'spell': 'Luoyang', 'spellShort': 'ly' },
  { 'id': '156', 'name': '南阳', 'spell': 'Nanyang', 'spellShort': 'ny' },
  { 'id': '157', 'name': '平顶山', 'spell': 'Pingdingshan', 'spellShort': 'pds' },
  { 'id': '158', 'name': '三门峡', 'spell': 'Sanmenxia', 'spellShort': 'smx' },
  { 'id': '159', 'name': '商丘', 'spell': 'Shangqiu', 'spellShort': 'sq' },
  { 'id': '160', 'name': '新乡', 'spell': 'Xinxiang', 'spellShort': 'xx' },
  { 'id': '161', 'name': '信阳', 'spell': 'Xinyang', 'spellShort': 'xy' },
  { 'id': '162', 'name': '许昌', 'spell': 'Xuchang', 'spellShort': 'xc' },
  { 'id': '163', 'name': '郑州', isHot: true, 'spell': 'Zhengzhou', 'spellShort': 'zz' },
  { 'id': '164', 'name': '周口', 'spell': 'Zhoukou', 'spellShort': 'zk' },
  { 'id': '165', 'name': '驻马店', 'spell': 'Zhumadian', 'spellShort': 'zmd' },
  { 'id': '166', 'name': '漯河', 'spell': 'LuoHe', 'spellShort': 'lh' },
  { 'id': '167', 'name': '濮阳', 'spell': 'PuYang', 'spellShort': 'py' },
  { 'id': '168', 'name': '大庆', 'spell': 'Daqing', 'spellShort': 'dq' },
  { 'id': '169', 'name': '大兴安岭', 'spell': 'Daxinganling', 'spellShort': 'dxal' },
  { 'id': '170', 'name': '哈尔滨', 'spell': 'Haerbin', 'spellShort': 'heb' },
  { 'id': '171', 'name': '鹤岗', 'spell': 'Hegang', 'spellShort': 'hg' },
  { 'id': '172', 'name': '黑河', 'spell': 'Heihe', 'spellShort': 'hh' },
  { 'id': '173', 'name': '鸡西', 'spell': 'Jixi', 'spellShort': 'jx' },
  { 'id': '174', 'name': '佳木斯', 'spell': 'Jiamusi', 'spellShort': 'jms' },
  { 'id': '175', 'name': '牡丹江', 'spell': 'Mudanjiang', 'spellShort': 'mdj' },
  { 'id': '176', 'name': '七台河', 'spell': 'Qitaihe', 'spellShort': 'qth' },
  { 'id': '177', 'name': '齐齐哈尔', 'spell': 'Qiqihaer', 'spellShort': 'qqhe' },
  { 'id': '178', 'name': '双鸭山', 'spell': 'Shuangyashan', 'spellShort': 'sys' },
  { 'id': '179', 'name': '绥化', 'spell': 'Suihua', 'spellShort': 'sh' },
  { 'id': '180', 'name': '伊春', 'spell': 'Yichun', 'spellShort': 'yc' },
  { 'id': '181', 'name': '鄂州', 'spell': 'Ezhou', 'spellShort': 'ez' },
  { 'id': '182', 'name': '恩施', 'spell': 'Enshitujiazumiaozuzizhizhou', 'spellShort': 'es' },
  { 'id': '183', 'name': '黄冈', 'spell': 'Huanggang', 'spellShort': 'hg' },
  { 'id': '184', 'name': '黄石', 'spell': 'Huangshi', 'spellShort': 'hs' },
  { 'id': '185', 'name': '荆门', 'spell': 'Jingmen', 'spellShort': 'jm' },
  { 'id': '186', 'name': '荆州', 'spell': 'Jingzhou', 'spellShort': 'jz' },
  { 'id': '187', 'name': '潜江', 'spell': 'Qianjiang', 'spellShort': 'qj' },
  { 'id': '188', 'name': '神农架', 'spell': 'Shennongjialinqu', 'spellShort': 'snj' },
  { 'id': '189', 'name': '十堰', 'spell': 'Shiyan', 'spellShort': 'sy' },
  { 'id': '190', 'name': '随州', 'spell': 'Suizhou', 'spellShort': 'sz' },
  { 'id': '191', 'name': '天门', 'spell': 'Tianmen', 'spellShort': 'tm' },
  { 'id': '192', 'name': '武汉', isHot: true, 'spell': 'Wuhan', 'spellShort': 'wh' },
  { 'id': '193', 'name': '仙桃', 'spell': 'Xiantao', 'spellShort': 'xt' },
  { 'id': '194', 'name': '咸宁', 'spell': 'Xianning', 'spellShort': 'xn' },
  { 'id': '195', 'name': '襄樊', 'spell': 'Xiangfan', 'spellShort': 'xf' },
  { 'id': '196', 'name': '孝感', 'spell': 'Xiaogan', 'spellShort': 'xg' },
  { 'id': '197', 'name': '宜昌', 'spell': 'Yichang', 'spellShort': 'yc' },
  { 'id': '198', 'name': '常德', 'spell': 'Changde', 'spellShort': 'cd' },
  { 'id': '199', 'name': '长沙', isHot: true, 'spell': 'Changsha', 'spellShort': 'cs' },
  { 'id': '200', 'name': '郴州', 'spell': 'Chenzhou', 'spellShort': 'cz' },
  { 'id': '201', 'name': '衡阳', 'spell': 'Hengyang', 'spellShort': 'hy' },
  { 'id': '202', 'name': '怀化', 'spell': 'Huaihua', 'spellShort': 'hh' },
  { 'id': '203', 'name': '娄底', 'spell': 'Loudi', 'spellShort': 'ld' },
  { 'id': '204', 'name': '邵阳', 'spell': 'Shaoyang', 'spellShort': 'sy' },
  { 'id': '205', 'name': '湘潭', 'spell': 'Xiangtan', 'spellShort': 'xt' },
  { 'id': '206', 'name': '湘西', 'spell': 'Xiangxi', 'spellShort': 'xx' },
  { 'id': '207', 'name': '益阳', 'spell': 'Yiyang', 'spellShort': 'yy' },
  { 'id': '208', 'name': '永州', 'spell': 'Yongzhou', 'spellShort': 'yz' },
  { 'id': '209', 'name': '岳阳', 'spell': 'Yueyang', 'spellShort': 'yy' },
  { 'id': '210', 'name': '张家界', 'spell': 'Zhangjiajie', 'spellShort': 'zjj' },
  { 'id': '211', 'name': '株洲', 'spell': 'Zhuzhou', 'spellShort': 'zz' },
  { 'id': '212', 'name': '白城', 'spell': 'Baicheng', 'spellShort': 'bc' },
  { 'id': '213', 'name': '白山', 'spell': 'Baishan', 'spellShort': 'bs' },
  { 'id': '214', 'name': '长春', 'spell': 'Changchun', 'spellShort': 'cc' },
  { 'id': '215', 'name': '吉林', 'spell': 'Jilin', 'spellShort': 'jl' },
  { 'id': '216', 'name': '辽源', 'spell': 'Liaoyuan', 'spellShort': 'ly' },
  { 'id': '217', 'name': '四平', 'spell': 'Siping', 'spellShort': 'sp' },
  { 'id': '218', 'name': '松原', 'spell': 'Songyuan', 'spellShort': 'sy' },
  { 'id': '219', 'name': '通化', 'spell': 'Tonghua', 'spellShort': 'th' },
  { 'id': '220', 'name': '延边', 'spell': 'Yanbian', 'spellShort': 'yb' },
  { 'id': '221', 'name': '常州', 'spell': 'Changzhou', 'spellShort': 'cz' },
  { 'id': '222', 'name': '淮安', 'spell': 'Huaian', 'spellShort': 'ha' },
  { 'id': '223', 'name': '连云港', 'spell': 'Lianyungang', 'spellShort': 'lyg' },
  { 'id': '224', 'name': '南京', isHot: true, 'spell': 'Nanjing', 'spellShort': 'nj' },
  { 'id': '225', 'name': '南通', 'spell': 'Nantong', 'spellShort': 'nt' },
  { 'id': '226', 'name': '苏州', 'spell': 'Suzhou', 'spellShort': 'sz' },
  { 'id': '227', 'name': '宿迁', 'spell': 'Suqian', 'spellShort': 'sq' },
  { 'id': '228', 'name': '泰州', 'spell': 'Taizhou', 'spellShort': 'tz' },
  { 'id': '229', 'name': '无锡', 'spell': 'Wuxi', 'spellShort': 'wx' },
  { 'id': '230', 'name': '徐州', 'spell': 'Xuzhou', 'spellShort': 'xz' },
  { 'id': '231', 'name': '盐城', 'spell': 'Yancheng', 'spellShort': 'yc' },
  { 'id': '232', 'name': '扬州', 'spell': 'Yangzhou', 'spellShort': 'yz' },
  { 'id': '233', 'name': '镇江', 'spell': 'Zhenjiang', 'spellShort': 'zj' },
  { 'id': '234', 'name': '抚州', 'spell': 'Fuzhou', 'spellShort': 'fz' },
  { 'id': '235', 'name': '赣州', 'spell': 'Ganzhou', 'spellShort': 'gz' },
  { 'id': '236', 'name': '吉安', 'spell': 'Jian', 'spellShort': 'ja' },
  { 'id': '237', 'name': '景德镇', 'spell': 'Jingdezhen', 'spellShort': 'jdz' },
  { 'id': '238', 'name': '九江', 'spell': 'Jiujiang', 'spellShort': 'jj' },
  { 'id': '239', 'name': '南昌', 'spell': 'Nanchang', 'spellShort': 'nc' },
  { 'id': '240', 'name': '萍乡', 'spell': 'Pingxiang', 'spellShort': 'px' },
  { 'id': '241', 'name': '上饶', 'spell': 'Shangrao', 'spellShort': 'sr' },
  { 'id': '242', 'name': '新余', 'spell': 'Xinyu', 'spellShort': 'xy' },
  { 'id': '243', 'name': '宜春', 'spell': 'Yichun', 'spellShort': 'yc' },
  { 'id': '244', 'name': '鹰潭', 'spell': 'Yingtan', 'spellShort': 'yt' },
  { 'id': '245', 'name': '鞍山', 'spell': 'Anshan', 'spellShort': 'as' },
  { 'id': '246', 'name': '本溪', 'spell': 'Benxi', 'spellShort': 'bx' },
  { 'id': '247', 'name': '朝阳', 'spell': 'Chaoyang', 'spellShort': 'cy' },
  { 'id': '248', 'name': '大连', isHot: true, 'spell': 'Dalian', 'spellShort': 'dl' },
  { 'id': '249', 'name': '丹东', 'spell': 'Dandong', 'spellShort': 'dd' },
  { 'id': '250', 'name': '抚顺', 'spell': 'Fushun', 'spellShort': 'fs' },
  { 'id': '251', 'name': '阜新', 'spell': 'Fuxin', 'spellShort': 'fx' },
  { 'id': '252', 'name': '葫芦岛', 'spell': 'Huludao', 'spellShort': 'hld' },
  { 'id': '253', 'name': '锦州', 'spell': 'Jinzhou', 'spellShort': 'jz' },
  { 'id': '254', 'name': '辽阳', 'spell': 'Liaoyang', 'spellShort': 'ly' },
  { 'id': '255', 'name': '盘锦', 'spell': 'Panjin', 'spellShort': 'pj' },
  { 'id': '256', 'name': '沈阳', 'spell': 'Shenyang', 'spellShort': 'sy' },
  { 'id': '257', 'name': '铁岭', 'spell': 'Tieling', 'spellShort': 'tl' },
  { 'id': '258', 'name': '营口', 'spell': 'Yingkou', 'spellShort': 'yk' },
  { 'id': '259', 'name': '阿拉善盟', 'spell': 'Alashanmeng', 'spellShort': 'alsm' },
  { 'id': '260', 'name': '巴彦淖尔', 'spell': 'Bayannaoer', 'spellShort': 'byne' },
  { 'id': '261', 'name': '包头', 'spell': 'Baotou', 'spellShort': 'bt' },
  { 'id': '262', 'name': '赤峰', 'spell': 'Chifeng', 'spellShort': 'cf' },
  { 'id': '263', 'name': '鄂尔多斯', 'spell': 'Eerduosi', 'spellShort': 'eeds' },
  { 'id': '264', 'name': '呼和浩特', 'spell': 'Huhehaote', 'spellShort': 'hhht' },
  { 'id': '265', 'name': '呼伦贝尔', 'spell': 'Hulunbeier', 'spellShort': 'hlbe' },
  { 'id': '266', 'name': '通辽', 'spell': 'Tongliao', 'spellShort': 'tl' },
  { 'id': '267', 'name': '乌海', 'spell': 'Wuhai', 'spellShort': 'wh' },
  { 'id': '268', 'name': '乌兰察布', 'spell': 'Wulanchabushi', 'spellShort': 'wlcb' },
  { 'id': '269', 'name': '锡林郭勒', 'spell': 'Xilinguole', 'spellShort': 'xlgl' },
  { 'id': '270', 'name': '兴安盟', 'spell': 'Xinganmeng', 'spellShort': 'xam' },
  { 'id': '271', 'name': '固原', 'spell': 'Guyuan', 'spellShort': 'gy' },
  { 'id': '272', 'name': '石嘴山', 'spell': 'Shizuishan', 'spellShort': 'szs' },
  { 'id': '273', 'name': '吴忠', 'spell': 'Wuzhong', 'spellShort': 'wz' },
  { 'id': '274', 'name': '银川', 'spell': 'Yinchuan', 'spellShort': 'yc' },
  { 'id': '275', 'name': '果洛', 'spell': 'Guoluocangzuzizhizhou', 'spellShort': 'gl' },
  { 'id': '276', 'name': '海北', 'spell': 'Haibeicangzuzizhizhou', 'spellShort': 'hb' },
  { 'id': '277', 'name': '海东', 'spell': 'Haidong', 'spellShort': 'hd' },
  { 'id': '278', 'name': '海南', 'spell': 'Hainancangzuzizhizhou', 'spellShort': 'hn' },
  { 'id': '279', 'name': '海西', 'spell': 'Haixi', 'spellShort': 'hx' },
  { 'id': '280', 'name': '黄南', 'spell': 'Huangnancangzuzizhizhou', 'spellShort': 'hn' },
  { 'id': '281', 'name': '西宁', 'spell': 'Xining', 'spellShort': 'xn' },
  { 'id': '282', 'name': '玉树', 'spell': 'Yushucangzuzizhizhou', 'spellShort': 'ys' },
  { 'id': '283', 'name': '滨州', 'spell': 'Binzhou', 'spellShort': 'bz' },
  { 'id': '284', 'name': '德州', 'spell': 'Dezhou', 'spellShort': 'dz' },
  { 'id': '285', 'name': '东营', 'spell': 'Dongying', 'spellShort': 'dy' },
  { 'id': '286', 'name': '菏泽', 'spell': 'Heze', 'spellShort': 'hz' },
  { 'id': '287', 'name': '济南', isHot: true, 'spell': 'Jinan', 'spellShort': 'jn' },
  { 'id': '288', 'name': '济宁', 'spell': 'Jining', 'spellShort': 'jn' },
  { 'id': '289', 'name': '莱芜', 'spell': 'Laiwu', 'spellShort': 'lw' },
  { 'id': '290', 'name': '聊城', 'spell': 'Liaocheng', 'spellShort': 'lc' },
  { 'id': '291', 'name': '临沂', 'spell': 'Linyi', 'spellShort': 'ly' },
  { 'id': '292', 'name': '青岛', isHot: true, 'spell': 'Qingdao', 'spellShort': 'qd' },
  { 'id': '293', 'name': '日照', 'spell': 'Rizhao', 'spellShort': 'rz' },
  { 'id': '294', 'name': '泰安', 'spell': 'Taian', 'spellShort': 'ta' },
  { 'id': '295', 'name': '威海', 'spell': 'Weihai', 'spellShort': 'wh' },
  { 'id': '296', 'name': '潍坊', 'spell': 'Weifang', 'spellShort': 'wf' },
  { 'id': '297', 'name': '烟台', 'spell': 'Yantai', 'spellShort': 'yt' },
  { 'id': '298', 'name': '枣庄', 'spell': 'Zaozhuang', 'spellShort': 'zz' },
  { 'id': '299', 'name': '淄博', 'spell': 'Zibo', 'spellShort': 'zb' },
  { 'id': '300', 'name': '长治', 'spell': 'Changzhi', 'spellShort': 'cz' },
  { 'id': '301', 'name': '大同', 'spell': 'Datong', 'spellShort': 'dt' },
  { 'id': '302', 'name': '晋城', 'spell': 'Jincheng', 'spellShort': 'jc' },
  { 'id': '303', 'name': '晋中', 'spell': 'Jinzhong', 'spellShort': 'jz' },
  { 'id': '304', 'name': '临汾', 'spell': 'Linfen', 'spellShort': 'lf' },
  { 'id': '305', 'name': '吕梁', 'spell': 'Lvliang', 'spellShort': 'll' },
  { 'id': '306', 'name': '朔州', 'spell': 'Shuozhou', 'spellShort': 'sz' },
  { 'id': '307', 'name': '太原', 'spell': 'Taiyuan', 'spellShort': 'ty' },
  { 'id': '308', 'name': '忻州', 'spell': 'Xinzhou', 'spellShort': 'xz' },
  { 'id': '309', 'name': '阳泉', 'spell': 'Yangquan', 'spellShort': 'yq' },
  { 'id': '310', 'name': '运城', 'spell': 'Yuncheng', 'spellShort': 'yc' },
  { 'id': '311', 'name': '安康', 'spell': 'Ankang', 'spellShort': 'ak' },
  { 'id': '312', 'name': '宝鸡', 'spell': 'Baoji', 'spellShort': 'bj' },
  { 'id': '313', 'name': '汉中', 'spell': 'Hanzhong', 'spellShort': 'hz' },
  { 'id': '314', 'name': '商洛', 'spell': 'Shangluo', 'spellShort': 'sl' },
  { 'id': '315', 'name': '铜川', 'spell': 'Tongchuan', 'spellShort': 'tc' },
  { 'id': '316', 'name': '渭南', 'spell': 'Weinan', 'spellShort': 'wn' },
  { 'id': '317', 'name': '西安', isHot: true, 'spell': 'Xian', 'spellShort': 'xa' },
  { 'id': '318', 'name': '咸阳', 'spell': 'Xianyang', 'spellShort': 'xy' },
  { 'id': '319', 'name': '延安', 'spell': 'Yanan', 'spellShort': 'ya' },
  { 'id': '320', 'name': '榆林', 'spell': 'Yulin', 'spellShort': 'yl' },
  { 'id': '321', 'name': '上海', isHot: true, 'spell': 'Shanghai', 'spellShort': 'sh' },
  { 'id': '322', 'name': '阿坝', 'spell': 'Abacangzuqiangzuzizhizhou', 'spellShort': 'ab' },
  { 'id': '323', 'name': '巴中', 'spell': 'Bazhong', 'spellShort': 'bz' },
  { 'id': '324', 'name': '成都', isHot: true, 'spell': 'Chengdu', 'spellShort': 'cd' },
  { 'id': '325', 'name': '达州', 'spell': 'Dazhou', 'spellShort': 'dz' },
  { 'id': '326', 'name': '德阳', 'spell': 'Deyang', 'spellShort': 'dy' },
  { 'id': '327', 'name': '甘孜', 'spell': 'Ganzi', 'spellShort': 'gz' },
  { 'id': '328', 'name': '广安', 'spell': 'Guangan', 'spellShort': 'ga' },
  { 'id': '329', 'name': '广元', 'spell': 'Guangyuan', 'spellShort': 'gy' },
  { 'id': '330', 'name': '乐山', 'spell': 'Leshan', 'spellShort': 'ls' },
  { 'id': '331', 'name': '凉山', 'spell': 'Liangshan', 'spellShort': 'ls' },
  { 'id': '332', 'name': '眉山', 'spell': 'Meishan', 'spellShort': 'ms' },
  { 'id': '333', 'name': '绵阳', 'spell': 'Mianyang', 'spellShort': 'my' },
  { 'id': '334', 'name': '南充', 'spell': 'Nanchong', 'spellShort': 'nc' },
  { 'id': '335', 'name': '内江', 'spell': 'Neijiang', 'spellShort': 'nj' },
  { 'id': '336', 'name': '攀枝花', 'spell': 'Panzhihua', 'spellShort': 'pzh' },
  { 'id': '337', 'name': '遂宁', 'spell': 'Suining', 'spellShort': 'sn' },
  { 'id': '338', 'name': '雅安', 'spell': 'Yaan', 'spellShort': 'ya' },
  { 'id': '339', 'name': '宜宾', 'spell': 'Yibin', 'spellShort': 'yb' },
  { 'id': '340', 'name': '资阳', 'spell': 'Ziyang', 'spellShort': 'zy' },
  { 'id': '341', 'name': '自贡', 'spell': 'Zigong', 'spellShort': 'zg' },
  { 'id': '342', 'name': '泸州', 'spell': 'LuZhou', 'spellShort': 'lz' },
  { 'id': '343', 'name': '天津', isHot: true, 'spell': 'Tianjin', 'spellShort': 'tj' },
  { 'id': '344', 'name': '阿里', 'spell': 'Ali', 'spellShort': 'al' },
  { 'id': '345', 'name': '昌都', 'spell': 'Changdu', 'spellShort': 'cd' },
  { 'id': '346', 'name': '拉萨', 'spell': 'Lasa', 'spellShort': 'ls' },
  { 'id': '347', 'name': '林芝', 'spell': 'Linzhi', 'spellShort': 'lz' },
  { 'id': '348', 'name': '那曲', 'spell': 'Naqu', 'spellShort': 'nq' },
  { 'id': '349', 'name': '日喀则', 'spell': 'Rikaze', 'spellShort': 'rkz' },
  { 'id': '350', 'name': '山南', 'spell': 'Shannan', 'spellShort': 'sn' },
  { 'id': '351', 'name': '阿克苏', 'spell': 'Akesu', 'spellShort': 'aks' },
  { 'id': '352', 'name': '阿拉尔', 'spell': 'Alaer', 'spellShort': 'ale' },
  { 'id': '353', 'name': '巴音郭楞', 'spell': 'Bayinguoleng', 'spellShort': 'bygl' },
  { 'id': '354', 'name': '博尔塔拉', 'spell': 'Boertalamengguzizhizhou', 'spellShort': 'betl' },
  { 'id': '355', 'name': '昌吉', 'spell': 'Changjihuizuzizhizhou', 'spellShort': 'cj' },
  { 'id': '356', 'name': '哈密', 'spell': 'Hami', 'spellShort': 'hm' },
  { 'id': '357', 'name': '和田', 'spell': 'Hetian', 'spellShort': 'ht' },
  { 'id': '358', 'name': '喀什', 'spell': 'Kashi', 'spellShort': 'ks' },
  { 'id': '359', 'name': '克拉玛依', 'spell': 'Kelamayi', 'spellShort': 'klmy' },
  { 'id': '360', 'name': '克孜', 'spell': 'Kezilesukeerkezizizhizhou', 'spellShort': 'kz' },
  { 'id': '361', 'name': '石河子', 'spell': 'Shihezi', 'spellShort': 'shz' },
  { 'id': '362', 'name': '图木舒克', 'spell': 'Tumushuke', 'spellShort': 'tmsk' },
  { 'id': '363', 'name': '吐鲁番', 'spell': 'Tulufan', 'spellShort': 'tlf' },
  { 'id': '364', 'name': '乌鲁木齐', 'spell': 'Wulumuqi', 'spellShort': 'wlmq' },
  { 'id': '365', 'name': '五家渠', 'spell': 'Wujiaqu', 'spellShort': 'wjq' },
  { 'id': '366', 'name': '伊犁', 'spell': 'Yili', 'spellShort': 'yl' },
  { 'id': '367', 'name': '保山', 'spell': 'Baoshan', 'spellShort': 'bs' },
  { 'id': '368', 'name': '楚雄', 'spell': 'Chuxiongyizuzizhizhou', 'spellShort': 'cx' },
  { 'id': '369', 'name': '大理', 'spell': 'Dali', 'spellShort': 'dl' },
  { 'id': '370', 'name': '德宏', 'spell': 'Dehongdaizujingpozuzizhizhou', 'spellShort': 'dh' },
  { 'id': '371', 'name': '迪庆', 'spell': 'Diqing', 'spellShort': 'dq' },
  { 'id': '372', 'name': '红河', 'spell': 'Honghehanizuyizuzizhizhou', 'spellShort': 'hh' },
  { 'id': '373', 'name': '昆明', isHot: true, 'spell': 'Kunming', 'spellShort': 'km' },
  { 'id': '374', 'name': '丽江', 'spell': 'Lijiang', 'spellShort': 'lj' },
  { 'id': '375', 'name': '临沧', 'spell': 'Lincang', 'spellShort': 'lc' },
  { 'id': '376', 'name': '怒江', 'spell': 'Nujianglilizuzizhizhou', 'spellShort': 'nj' },
  { 'id': '377', 'name': '曲靖', 'spell': 'Qujing', 'spellShort': 'qj' },
  { 'id': '378', 'name': '思茅', 'spell': 'Simao', 'spellShort': 'sm' },
  { 'id': '379', 'name': '文山', 'spell': 'Wenshanzhuangzumiaozuzizhizhou', 'spellShort': 'ws' },
  { 'id': '380', 'name': '西双版纳', 'spell': 'Xishuangbanna', 'spellShort': 'xsbn' },
  { 'id': '381', 'name': '玉溪', 'spell': 'Yuxi', 'spellShort': 'yx' },
  { 'id': '382', 'name': '昭通', 'spell': 'Zhaotong', 'spellShort': 'zt' },
  { 'id': '383', 'name': '杭州', isHot: true, 'spell': 'Hangzhou', 'spellShort': 'hz' },
  { 'id': '384', 'name': '湖州', 'spell': 'Huzhou', 'spellShort': 'hz' },
  { 'id': '385', 'name': '嘉兴', 'spell': 'Jiaxing', 'spellShort': 'jx' },
  { 'id': '386', 'name': '金华', 'spell': 'Jinhua', 'spellShort': 'jh' },
  { 'id': '387', 'name': '丽水', 'spell': 'Lishui', 'spellShort': 'ls' },
  { 'id': '388', 'name': '宁波', 'spell': 'Ningbo', 'spellShort': 'nb' },
  { 'id': '389', 'name': '绍兴', 'spell': 'Shaoxing', 'spellShort': 'sx' },
  { 'id': '390', 'name': '台州', 'spell': 'Taizhou', 'spellShort': 'tz' },
  { 'id': '391', 'name': '温州', 'spell': 'Wenzhou', 'spellShort': 'wz' },
  { 'id': '392', 'name': '舟山', 'spell': 'Zhoushan', 'spellShort': 'zs' },
  { 'id': '393', 'name': '衢州', 'spell': 'QuZhou', 'spellShort': 'qz' },
  { 'id': '394', 'name': '重庆', isHot: true, 'spell': 'Chongqing', 'spellShort': 'cq' },
  { 'id': '395', 'name': '香港', 'spell': 'Xianggang', 'spellShort': 'xg' },
  { 'id': '396', 'name': '澳门', 'spell': 'Aomen', 'spellShort': 'am' },
  { 'id': '397', 'name': '高雄', 'spell': 'Gaoxiong', 'spellShort': 'gx' },
  { 'id': '398', 'name': '花莲', 'spell': 'Hualian', 'spellShort': 'hl' },
  { 'id': '399', 'name': '基隆', 'spell': 'Jilong', 'spellShort': 'jl' },
  { 'id': '400', 'name': '嘉义', 'spell': 'Jiayi', 'spellShort': 'jy' },
  { 'id': '401', 'name': '台北', 'spell': 'Taibei', 'spellShort': 'tb' },
  { 'id': '402', 'name': '台东', 'spell': 'Taidong', 'spellShort': 'td' },
  { 'id': '403', 'name': '台南', 'spell': 'Tainan', 'spellShort': 'tn' },
  { 'id': '404', 'name': '台中', 'spell': 'Taizhong', 'spellShort': 'tz' },
  { 'id': '3105', 'name': '中卫', 'spell': 'Zhongwei', 'spellShort': 'zw' },
  { 'id': '3113', 'name': '塔城', 'spell': 'Tacheng', 'spellShort': 'tc' },
  { 'id': '3114', 'name': '阿勒泰', 'spell': 'Aletai', 'spellShort': 'alt' },
  { 'id': '3143', 'name': '乌苏里江', 'spell': 'Wusulijiang', 'spellShort': 'wslj' },
  { 'id': '3280', 'name': '赤壁市', 'spell': 'Chibishi', 'spellShort': 'cbs' },
  { 'id': '3281', 'name': '顺德', 'spell': 'Shunde', 'spellShort': 'sd' }
]



// WEBPACK FOOTER //
// ./src/components/hotelCityData.js